import { EarnTab } from '../raw-tab-configs/earn-tab';
import { HomeTab } from '../raw-tab-configs/home-tab';
import { MenuTab } from '../raw-tab-configs/menu-tab';
import { RewardsTab } from '../raw-tab-configs/rewards-tab';
import { StoreLocatorTab } from '../raw-tab-configs/store-locator-tab';
import type { RawTab } from '../types';

export const tabList: Array<RawTab> = [HomeTab, RewardsTab, MenuTab, EarnTab, StoreLocatorTab];
export const tabListWithoutEarn: Array<RawTab> = [HomeTab, RewardsTab, MenuTab, StoreLocatorTab];
